export const WEB_FRONTEND = 'web-frontend';
